/* ══════════════════════════════════════════════════════════════
   Gujarati (gu) — ગુજરાતી Translation File
   ══════════════════════════════════════════════════════════════ */

export const gu = {
    app: {
        name: 'ઇન્ડિયા માર્કેટ મોનિટર',
        tagline: 'AI-સંચાલિત ભારતીય બજાર બુદ્ધિમત્તા',
    },
    nav: {
        dashboard: 'ડેશબોર્ડ',
        strategy: 'વ્યૂહરચના',
        intelligence: 'ઇન્ટેલિજન્સ',
        markets: 'બજારો',
        indiaMap: 'ભારતનો નકશો',
        ipoEarnings: 'IPO અને આવક',
        backtest: 'બેકટેસ્ટ',
        settings: 'સેટિંગ્સ',
        search: 'કંપની, સમાચાર શોધો…',
    },
    dashboard: {
        title: 'ડેશબોર્ડ',
        marketStatus: 'બજારની સ્થિતિ',
        open: 'ખુલ્લું',
        closed: 'બંધ',
        preOpen: 'પ્રી-ઓપન',
        holiday: 'રજા',
        strategyCard: 'આજની વ્યૂહરચના',
        marketRadar: 'માર્કેટ રેડાર',
        fiiDii: 'FII / DII પ્રવાહ',
        quickStats: 'ઝડપી આંકડા',
        newsTicker: 'અગ્રતા સમાચાર',
        liveTV: 'લાઇવ ટીવી',
        viewDetails: 'વિગતો જુઓ →',
    },
    strategy: {
        title: 'વ્યૂહરચના',
        regime: 'બજાર રિજીમ',
        regimeTypes: {
            trendingBull: 'તેજીનો ટ્રેન્ડ',
            trendingBear: 'મંદીનો ટ્રેન્ડ',
            sideways: 'સાઇડવેઝ',
            highVol: 'ઉચ્ચ અસ્થિરતા',
        },
        confidence: 'વિશ્વાસ',
        entry: 'એન્ટ્રી',
        target: 'લક્ષ્ય',
        stopLoss: 'સ્ટોપ લોસ',
        buy: 'ખરીદો',
        sell: 'વેચો',
        hold: 'હોલ્ડ',
        featureImportance: 'ફીચર મહત્વ',
        keyLevels: 'મુખ્ય સ્તરો',
        support: 'સપોર્ટ',
        resistance: 'રેઝિસ્ટન્સ',
        currentPrice: 'વર્તમાન ભાવ',
    },
    intelligence: {
        title: 'ઇન્ટેલિજન્સ',
        morningBrief: 'સવારનો સારાંશ',
        priorityFeed: 'અગ્રતા ફીડ',
        sectorIntel: 'ક્ષેત્ર ઇન્ટેલિજન્સ',
        earningsTracker: 'આવક',
        eventTimeline: 'ઘટનાઓ',
        newsSearch: 'શોધ',
        bullish: 'તેજી',
        bearish: 'મંદી',
        neutral: 'તટસ્થ',
    },
    markets: {
        title: 'બજારો',
        indices: 'ઇન્ડેક્સ',
        options: 'ઓપ્શન્સ',
        sectors: 'ક્ષેત્રો',
        commodities: 'કોમોડિટી',
        currency: 'ચલણ',
        breadth: 'બ્રેડ્થ',
        advancing: 'વધતા',
        declining: 'ઘટતા',
    },
    ipo: {
        title: 'IPO અને આવક',
        dashboard: 'IPO ડેશબોર્ડ',
        earningsTracker: 'આવક ટ્રેકર',
        upcoming: 'આવનારા IPO',
        subscribe: 'સબસ્ક્રાઇબ',
        avoid: 'ટાળો',
        revenue: 'આવક',
        verdict: 'ચુકાદો',
        beat: 'બીટ',
        miss: 'મિસ',
    },
    backtest: {
        title: 'બેકટેસ્ટ',
        equityCurve: 'ઇક્વિટી કર્વ',
        riskMetrics: 'રિસ્ક મેટ્રિક્સ',
        monthlyReturns: 'માસિક વળતર',
        tradeLog: 'ટ્રેડ લોગ',
        totalReturn: 'કુલ વળતર',
        winRate: 'જીત દર',
    },
    map: {
        title: 'ભારતનો નકશો',
        selectState: 'રાજ્ય પસંદ કરો',
        gdp: 'GDP',
        growth: 'વૃદ્ધિ',
        keySectors: 'મુખ્ય ક્ષેત્રો',
    },
    settings: {
        title: 'સેટિંગ્સ',
        language: 'ભાષા',
        selectLanguage: 'ભાષા પસંદ કરો',
        darkMode: 'ડાર્ક મોડ',
        lightMode: 'લાઇટ મોડ',
    },
    sectorRotation: {
        title: 'ક્ષેત્ર રોટેશન',
        leading: 'આગળ',
        weakening: 'નબળું',
        lagging: 'પાછળ',
        improving: 'સુધારો',
    },
    election: {
        title: 'ચૂંટણી પ્રભાવ',
        upcomingElections: 'આવનારી ચૂંટણીઓ',
        state: 'રાજ્ય',
        historicalImpact: 'ઐતિહાસિક નિફ્ટી પ્રભાવ',
        avgReturn: 'સરેરાશ નિફ્ટી વળતર',
    },
    budget: {
        title: 'બજેટ પ્રભાવ',
        unionBudget: 'કેન્દ્રીય બજેટ 2026-27',
        daysLeft: '{{days}} દિવસ બાકી',
        increase: 'વધારો',
        decrease: 'ઘટાડો',
    },
    common: {
        loading: 'લોડ થઈ રહ્યું છે…',
        error: 'કંઈક ખોટું થયું',
        retry: 'ફરી પ્રયાસ કરો',
        noData: 'કોઈ ડેટા ઉપલબ્ધ નથી',
        viewAll: 'બધું જુઓ',
        close: 'બંધ કરો',
        save: 'સાચવો',
        cancel: 'રદ કરો',
        crore: 'કરોડ',
        lakh: 'લાખ',
        rupee: '₹',
        disclaimer: 'આ નાણાકીય સલાહ નથી. ફક્ત માહિતી માટે.',
    },
};
